export default __webpack_public_path__ + "static/media/floor-hockey.d0576be3.svg";